import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { ProcessName, RegisterCompletedProcess } from '../../../../../global/helpers/analytics-helper';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { useLockedPageState } from '../../../../../global/hooks/useLockedPageState';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { LockedPageKeys } from '../../../../../global/models/locked-page-model';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { FormTypes } from '../../../../account-info/models/form-models';
import { ArcRoutes } from '../../../constants/routes';
import { EmploymentState } from '../../employment/employment-model';
import { CompensationHistoryState } from '../compensation-history/compensation-history-model';
import { setCalculatedTotals, setUpdateCompensationStatus } from '../compensation-history/compensation-history-slice';
import { getCurrentScheduledPayment, getScheduledPaymentById } from '../compensation-history/compensation-selectors';
import { ScheduledPaymentForm } from './scheduled-payment-form';
import { ScheduledPaymentFormValues } from './scheduled-payment-form-model';
import { calculateTotals, patchScheduledPayments, postScheduledPayment } from './scheduled-payment-request';

export function ScheduledPayment() {
    const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const compensationState = useSelector<TcsmStates, CompensationHistoryState>(state => state.compensationHistoryState);
    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const basePath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.Compensation}`);
    const employmentPage = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.Employment}`);
    const dispatch = useDispatch();
    const history = useHistory();

    const lockedState = useLockedPageState(LockedPageKeys.Compensation);

	useEffect(() => {
        dispatch(apiErrorClear());
        dispatch(setUpdateCompensationStatus(ApiStatuses.None));
		dispatch(setCalculatedTotals(null));
	}, []);

	const { scheduledPaymentNumber } = useParams<any>();

	const currentScheduledPayment = scheduledPaymentNumber
		? getScheduledPaymentById(compensationState.allScheduledPayments, scheduledPaymentNumber)
		: getCurrentScheduledPayment(compensationState.allScheduledPayments);


    const handleCalculateTotals = (formValues: ScheduledPaymentFormValues) => {
        setTimeout(() => {            
            calculateTotals(dispatch, employmentState?.currentEmployee?.id, formValues, employmentState?.currentEmployment?.id);
        }, 200);
	};

    const handleSubmit = (initialValues: ScheduledPaymentFormValues, formValues: ScheduledPaymentFormValues) => {

        if (scheduledPaymentNumber) {
            patchScheduledPayments(dispatch, employmentState?.currentEmployee?.id, initialValues, formValues, currentScheduledPayment);
        } else {
            postScheduledPayment(dispatch, employmentState?.currentEmployee?.id, initialValues, formValues, employmentState?.currentEmployment?.id);
        }

        RegisterCompletedProcess(ProcessName.ScheduledPayment);
    };

    if (lockedState.isLocked) {
        history.push(employmentPage);
    }

    // redirect to individual compensation page on success with query string
    if (compensationState?.updateCompensationStatus === ApiStatuses.Success) {
        return (<Redirect to={{
            pathname: `${basePath}`,
            search: `?success=${FormTypes.COMPENSATION}`,
        }} />);
    }

	return (
		<>
            <ScheduledPaymentForm
                formHeader={epiProps.compensationSettingsState.epiContent.scheduledPaymentPageTitle}
                formDescription={epiProps.compensationSettingsState.epiContent.scheduledPaymentDescription}
                compensationProps={epiProps?.compensationSettingsState?.epiContent}
                labelSettings={epiProps?.labelSettingState?.epiContent}
                currentScheduledPayment={currentScheduledPayment}
                currentEmployment={employmentState.currentEmployment}
                onSubmitHandler={handleSubmit}
                onCalculateTotals={handleCalculateTotals}
                temporaryCalculatedTotals={compensationState?.temporaryCalculatedTotals}
                previousRoute={basePath}
                isEdit={!!scheduledPaymentNumber}
			/>

		</>
	);
}